import FlintTextBox from "@components//controls/FlintTextBox";
import * as icons from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import styles from "./GridSearchBox.module.scss";
import React, {CSSProperties, useEffect, useMemo, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {CommonUtils} from "@utils/CommonUtils";
import NewGuid = CommonUtils.NewGuid;
import {InputHandle, InputPrefix, InputProps, TextBox, TextBoxHandle} from "@progress/kendo-react-inputs";
import {FloatingLabel} from "@progress/kendo-react-labels";

export default function GridSearchBox(props: GridSearchBoxProps) {
    const {state, handlers} = useGridSearchBox(props);
    const {t} = useTranslation();
    const {
        onSearch,
        placeholder = t("COMMON_SearchFieldLabel").toLowerCase(),
        label = t("COMMON_SearchFieldLabel").toLowerCase(),
        ...other
    } = props;

    return (
        <div ref={state.wrapperRef} className={styles.flintSearchBoxWrapper}>
            <div className={`${styles.flintSearchBox} ${state.iconVisible.get ? "icon-visible" : ""}`}>
                {state.iconVisible.get && <FontAwesomeIcon className={styles.flintSearchBoxIcon} size={"1x"} icon={icons.faSearch}/>}
                <FlintTextBox
                    {...other}
                    label={label}
                    placeholder={label != null ? '' : placeholder}
                    onFocus={() => state.iconVisible.set(false)}
                    onBlur={e => handlers.handleSetSearch(e.currentTarget as HTMLInputElement)} type={"search"}
                    onEnterPressed={e => handlers.handleSetSearch(e.currentTarget as HTMLInputElement, false)}/>
            </div>
        </div>
    )
}

export interface GridSearchBoxProps extends InputProps {
    onSearch: (search: string) => void;
}

function useGridSearchBox(props: GridSearchBoxProps) {
    const [iconVisible, setIconVisible] = useState<boolean>(true);
    const wrapperRef = useRef<HTMLDivElement>(null);

    const currentValueRef = useRef<string>();

    function handleSetSearch(tb: HTMLInputElement, verifyIconVisibility: boolean = true) {
        if (currentValueRef.current != tb.value) {
            props.onSearch(tb.value);
            currentValueRef.current = tb.value;
        }
        if (!verifyIconVisibility)
            return;
        let containsText = tb.value?.length > 0;
        setIconVisible(!containsText);
    }


    useEffect(() => {
        const wrapperElement = wrapperRef.current;
        if (!wrapperElement)
            return;
        const searchInput = wrapperElement.querySelector('input[type="search"]') as HTMLInputElement | null;
        if (!searchInput)
            return;
        currentValueRef.current = searchInput?.value;
        const handleSearch = (e: any) => {
            if (e.currentTarget.value)
                return;
            console.debug("=Grid filter reset=");
            currentValueRef.current = "";
            props.onSearch("");
        }
        searchInput.addEventListener("search", handleSearch);
        return () => {
            searchInput.removeEventListener("search", handleSearch);
        }
    }, [])
    return {
        state: {
            iconVisible: {get: iconVisible, set:setIconVisible},
            wrapperRef
        },
        handlers: {
            handleSetSearch
        }
    }
}